import moment from 'moment';
import { legacyApiFilterBuilder } from '../../../filters/legacy-api-filter-builder';
import { getAdvancedSearchBatches } from '../api';
import { getBatchRowsSuccess, getBatchRowsFailure } from '../../../store/batches/grid/batches.grid.actions';
import { id as fulfillmentTypeId } from '../../../filters/options/fulfillment-type';
import { batches } from '../../../filters/options/fulfillment-type/options';
import { id as shipDateId } from '../../../filters/options/ship-date';
import { id as createdDateId } from '../../../filters/options/created-date';
import { BatchesAdvancedSearch } from '../../../components/shipping-grid/views/batches-advanced-search';
import Global from '../../../store/global-selectors';
import { setTotalRecords } from '../../../store/paging/paging.actions';

const pagingViewName = 'batches.grid';

export default {
  filterBuilder: legacyApiFilterBuilder,
  apiCall: getAdvancedSearchBatches,
  baseUrl: 'batches',
  successActions: [getBatchRowsSuccess, (_, __, ___, totalCount) => setTotalRecords(pagingViewName, totalCount)],
  failureAction: getBatchRowsFailure,
  convertResponse: (response) => response,
  getOrderBy: (reduxState) => ({
    orderBy: Global.selectBatchesGridSortBy(reduxState),
  }),
  view: BatchesAdvancedSearch,
  initialFilters: [
    {
      id: fulfillmentTypeId,
      value: batches.apiKey,
    },
    {
      id: shipDateId,
      value: {
        from: moment().add(-90, 'days'),
      },
    },
    {
      id: createdDateId,
      value: {
        from: moment().add(-90, 'days'),
      },
    },
  ],
};
